module.exports = __webpack_public_path__ + "static/media/share.29f6d5af.svg";